"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Group = void 0;
const result_1 = require("./result");
const state_type_1 = require("./state-type");
const symbols_1 = require("./symbols");
/**
 * Describes a state machine group and its states.
 */
class Group {
    constructor(name) {
        this.name = name;
        this.registeredStates = [];
        this.registeredHandlers = {};
    }
    /**
     * Registers a new state in the group.
     */
    registerState(name, signalsHandlers) {
        // console.debug(`Registering state ${String(this.name)}(${name})`);
        // create a new state factory
        // basically, it's a function that returns a new state instance with custom type guard
        const state = function (props) {
            return new state_type_1.StateInstance(state, name, props);
        };
        // and some metadata and static methods
        state.is = function (state) {
            return state instanceof state_type_1.StateInstance && state[symbols_1.stateNameSym] === name;
        };
        state.stateName = name;
        state.groupName = this.name;
        this.registeredStates.push(state);
        this.registeredHandlers[name] = signalsHandlers;
        return state;
    }
    bootstrap(factory) {
        this.initFactory = factory;
        return this;
    }
    /**
     * Returns true if the group accepts the signal.
     */
    accepts(state, signal) {
        return signal in this.registeredHandlers[state[symbols_1.stateNameSym]];
    }
    /**
     * Handles the signal in current state.
     */
    handle(snapshot, signal, params) {
        const state = snapshot[this.name];
        const handler = this.registeredHandlers[state[symbols_1.stateNameSym]][signal];
        if (handler == null) {
            return result_1.Result.ignore(`Signal ${String(signal)} is not handled in state ${state[symbols_1.stateNameSym]}`);
        }
        try {
            const tmp = handler(snapshot, params);
            // if (result.kind === ResultKind.Handled && result.state != null) {
            //   collector.log(
            //     `State: ${String(this.name)}(${state[stateNameSym]}) => ${String(this.name)}(${result.state[stateNameSym]})`,
            //     { ...result.state },
            //   );
            // }
            return tmp instanceof result_1.Result
                ? tmp
                : tmp instanceof state_type_1.StateInstance
                    ? result_1.Result.ok(tmp)
                    : result_1.Result.ok(state_type_1.StateInstance.clone(state, tmp));
        }
        catch (err) {
            return result_1.Result.error(err);
        }
    }
}
exports.Group = Group;
//# sourceMappingURL=group.js.map